/** MyListings.jsx – Premium UI (Restored Cards + Cleaning Swaps SAFE) */
import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import logo from "../assets/logo.png";
import { API_BASE_URL } from "../config";

export default function MyListings() {
  const [listings, setListings] = useState([]);
  const navigate = useNavigate();
  

  useEffect(() => {
    async function loadAll() {
      try {
        const token = localStorage.getItem("token");
        const user = JSON.parse(localStorage.getItem("user"));

        const headers = {
          Authorization: `Bearer ${token}`,
          "user-id": user?.id,
        };

 // ✅ KEEP EXISTING WORKING REQUESTS — SAFE VERSION
const responses = await Promise.allSettled([
  axios.get(`${API_BASE_URL}/api/listings/my`, { headers }),
  axios.get(`${API_BASE_URL}/api/lawn-mowing/rounds/my`, { headers }),
  axios.get(`${API_BASE_URL}/api/lawn-mowing/business/my`, { headers }),
  axios.get(`${API_BASE_URL}/api/lawn-mowing/franchises/my`, { headers }),

  // CLEANING
  axios.get(`${API_BASE_URL}/api/cleaning/listings/my`, { headers }),
  axios.get(`${API_BASE_URL}/api/cleaning/rounds/my`, { headers }),
  axios.get(`${API_BASE_URL}/api/cleaning/business/my/listings`, {
    headers,
    params: { user_id: user?.id },
  }),

  // CLEANING FRANCHISES
  axios.get(`${API_BASE_URL}/api/cleaning/franchises/my`, { headers }),

  // ✅ POOLCARE LISTINGS
  axios.get(`${API_BASE_URL}/api/poolcare/listings/my`, { headers }),
]);

const [
  classic,
  rounds,
  business,
  franchises,
  cleaning,
  cleaningRounds,
  cleaningBusinesses,
  cleaningFranchises,
  poolcareListings,
] = responses.map((res) =>
  res.status === "fulfilled" ? res.value : { data: [] }
);

let all = [];



/* =====================================================
   ADD POOL CARE BUSINESS / FRANCHISE (OWNER LISTINGS)
   SAFE – DOES NOT BREAK MY LISTINGS
===================================================== */
try {
  const poolcareBFRes = await axios.get(
    `${API_BASE_URL}/api/poolcare/business-franchise/my`,
    { headers }
  );

poolcareBFRes.data?.listings?.forEach((b) =>
  all.push({
    id: b.id,
    listingId: `PCB-${b.id}`,
    type: "poolcare_business",
    title:
      b.listing_type === "franchise"
        ? b.franchise_brand
        : b.business_title || "Pool Care Business",
    suburb: `${b.suburb}, ${b.state}`,
    price: b.price,
    status:
      b.status === "completed"
        ? "completed"
        : b.status === "sold"
        ? "sold"
        : b.status === "expired"
        ? "expired"
        : b.status,
  })
);
} catch (err) {
  console.warn("Pool care business/franchise not loaded (safe)");
}


  /* =====================================================
   ADD CLEANING SWAPS (OWNER LISTINGS)
   SAFE – DOES NOT BREAK MY LISTINGS
===================================================== */
try {
  const swapsRes = await axios.get(
    `${API_BASE_URL}/api/cleaning/swap-listings/user/${user.id}`,
    { headers }
  );

swapsRes.data?.listings?.forEach((s) =>
  all.push({
    id: s.id,
    listingId: s.listingId,
    type: "cleaning_swap",
    title: `${s.frequency} swap in ${s.swap_from_suburb}`,
    suburb: `${s.swap_from_suburb}, ${s.swap_to_state}`,
    price: s.avg_job_price,
    status:
      s.swap_status === "completed"
        ? "completed"
        : s.swap_status === "handover"
        ? "handover"
        : s.swap_status === "locked"
        ? "locked"
        : s.hidden === 1
        ? "inactive"
        : "available",
  })
);
} catch (err) {
  console.warn("Cleaning swaps not loaded (safe)");
}



/* =====================================================
   ADD POOL CARE SWAPS (OWNER LISTINGS)
===================================================== */
try {
  const poolSwapsRes = await axios.get(
    `${API_BASE_URL}/api/poolcare/swap-listings/user/${user.id}`,
    { headers }
  );

poolSwapsRes.data?.listings?.forEach((s) =>
  all.push({
    id: s.id,
    listingId: s.listingId,
    type: "poolcare_swap",
    title: `${s.frequency} swap in ${s.swap_from_suburb}`,
    suburb: `${s.swap_from_suburb}, ${s.swap_to_state}`,
    price: s.serviceFee ?? 0,
    status:
      s.swap_status === "completed"
        ? "completed"
        : s.swap_status === "handover"
        ? "handover"
        : s.swap_status === "locked"
        ? "locked"
        : s.hidden === 1
        ? "inactive"
        : "available",
  })
);
} catch (err) {
  console.warn("Pool care swaps not loaded (safe)");
}


/* =====================================================
   ADD LAWN MOWING SWAPS (OWNER LISTINGS)
===================================================== */
try {
  const mowingSwapsRes = await axios.get(
    `${API_BASE_URL}/api/swap-listings/user/${user.id}`
  );


mowingSwapsRes.data?.listings?.forEach((s) =>
  all.push({
    id: s.id,
    listingId: s.listingId,
    type: "mowing_swap",
    title: `Swap – Lawn Mowing`,
    suburb: `${s.swap_from_suburb}, ${s.swap_from_postcode}`,
    price: s.cutValue,
    status:
      s.swap_status === "completed"
        ? "completed"
        : s.swap_status === "handover"
        ? "handover"
        : s.swap_status === "locked"
        ? "locked"
        : s.hidden === 1
        ? "inactive"
        : "available",
  })
);
} catch (err) {
  console.warn("Mowing swaps not loaded (safe)");
}



        /* ===== CLASSIC LISTINGS ===== */
     classic.data?.forEach((l) =>
  all.push({
    id: l.id,
    listingId: l.listingId,
    type: "listing",
    title: `${l.frequency} in ${l.suburb}`,
    suburb: l.suburb,
    price: l.price,
    status:
      l.listing_status === "completed"
        ? "completed"
        : l.listing_status === "sold"
        ? "sold"
        : l.listing_status === "expired"
        ? "expired"
        : l.listing_status,
  })
);

        /* ===== ROUNDS ===== */
     rounds.data?.listings?.forEach((r) =>
  all.push({
    id: r.id,
    type: "round",
    title: r.title || `Round in ${r.suburb}`,
    suburb: `${r.suburb}, ${r.state}`,
    price: r.price,
    status:
      r.status === "completed"
        ? "completed"
        : r.status === "sold"
        ? "sold"
        : r.status === "expired"
        ? "expired"
        : r.status,
  })
);



        /* ===== CLEANING ROUNDS ===== */
cleaningRounds.data?.listings?.forEach((r) =>
  all.push({
    id: r.id,
    type: "cleaning_round",
    title: r.title || `Cleaning round in ${r.suburb}`,
    suburb: `${r.suburb}, ${r.state}`,
    price: r.price,
    status:
      r.status === "completed"
        ? "completed"
        : r.status === "sold"
        ? "sold"
        : r.status === "expired"
        ? "expired"
        : r.status,
  })
);


        /* ===== BUSINESS ===== */
        business.data?.listings?.forEach((b) =>
          all.push({
            id: b.id,
            listingId: `BUS-${b.id}`,
            type: "business",
            title: b.business_title,
            suburb: `${b.suburb}, ${b.state}`,
            price: b.price,
            status: b.status,
          })
        );

      /* ===== CLEANING BUSINESS ===== */
cleaningBusinesses.data?.listings?.forEach((b) =>
  all.push({
    id: b.id,
    type: "cleaning_business",
    title: b.business_title,
    suburb: `${b.suburb}, ${b.state}`,
    price: b.price,
    status: b.status || "draft", // ✅ ensure draft shows
  })
);



        /* ===== FRANCHISE ===== */
        franchises.data?.listings?.forEach((f) =>
          all.push({
            id: f.id,
            type: "franchise",
            title: f.franchise_brand,
            suburb: `${f.suburb || ""} ${f.state || ""}`,
            price: f.price,
            status: f.status,
          })
        );

        /* ===== CLEANING LISTINGS ===== */
        cleaning.data?.listings?.forEach((c) =>
  all.push({
    id: c.id,
    listingId: c.listingId,
    type: "cleaning",
    title: `${c.frequency} clean in ${c.suburb}`,
    suburb: `${c.suburb}, ${c.state}`,
    price: c.salePrice,
    status:
      c.listing_status === "completed"
        ? "completed"
        : c.listing_status === "sold"
        ? "sold"
        : c.listing_status === "expired"
        ? "expired"
        : c.listing_status,
  })
);

        /* ===== CLEANING FRANCHISE ===== */
cleaningFranchises.data?.listings?.forEach((f) =>
  all.push({
    id: f.id,
    type: "cleaning_franchise",
    title: f.franchise_brand,
    suburb: `${f.suburb || ""} ${f.state || ""}`,
    price: f.price,
    status: f.status,
  })
);

        /* ===== POOLCARE LISTINGS ===== */
poolcareListings.data?.listings?.forEach((p) =>
  all.push({
    id: p.id,
    listingId: p.listingId,
    type: "poolcare_listing",
    title: `${p.frequency} in ${p.suburb}`,
    suburb: `${p.suburb}, ${p.state}`,
    price: p.salePrice,
    status:
      p.listing_status === "completed"
        ? "completed"
        : p.listing_status === "sold"
        ? "sold"
        : p.listing_status === "expired"
        ? "expired"
        : p.hidden === 1
        ? "inactive"
        : p.listing_status,
  })
);



   
     all.sort((a, b) => b.id - a.id);

all.sort((a, b) => b.id - a.id);
setListings(all);

      } catch (err) {
        console.error("MY LISTINGS LOAD ERROR:", err);
      }
    }

    loadAll();
  }, [API_BASE_URL]);

/* ===== VIEW ===== */
const openListing = (item) => {
  if (item.type === "round") {
    navigate(`/lawn-mowing/rounds/${item.id}`);
  } 
  else if (item.type === "cleaning_round") {
    navigate(`/cleaning/rounds/${item.id}`);
  }
  else if (item.type === "business") {
    navigate(`/lawn-mowing/business/${item.id}`);
  }
  else if (item.type === "cleaning_business") {
    navigate(`/cleaning/business/${item.id}`);
  }

  else if (item.type === "cleaning_franchise") {
  navigate(`/cleaning/franchises/${item.id}`);
}
  else if (item.type === "franchise") {
    navigate(`/lawn-mowing/franchises/${item.id}`);
  }
  else if (item.type === "poolcare_business") {
    navigate(`/poolcare/businesses/${item.id}`);
  }
  else if (item.type === "cleaning") {
    navigate(`/cleaning/listing/${item.listingId}`);
  }

  /* ✅ ADD THIS BLOCK */
  else if (item.type === "poolcare_listing") {
    navigate(`/poolcare/listing/${item.listingId}`);
  }

  else if (item.type === "cleaning_swap") {
    navigate(`/cleaning/swaps/${item.listingId}`);
  }
  else if (item.type === "poolcare_swap") {
    navigate(`/poolcare/swaps/${item.listingId}`);
  }
  else if (item.type === "mowing_swap") {
    navigate(`/swap/${item.id}`, {
      state: { fromMyListings: true },
    });
  }
  else {
    navigate(`/listing/${item.id}`);
  }
};




  

/* ===== EDIT ===== */
const editListing = (item) => {
  if (item.type === "listing") {
    navigate(`/edit-listing/${item.id}`);
  }
  else if (item.type === "round") {
    navigate(`/lawn-mowing/rounds/edit/${item.id}`);
  }
  else if (item.type === "cleaning_round") {
    navigate(`/cleaning/rounds/edit/${item.id}`);
  }
  else if (item.type === "business") {
    navigate(`/lawn-mowing/business/edit/${item.id}`);
  }
  else if (item.type === "cleaning_business") {
    navigate(`/cleaning/business/edit/${item.id}`);
  }
  else if (item.type === "cleaning_franchise") {
  navigate(`/cleaning/franchises/edit/${item.id}`);
}
  else if (item.type === "franchise") {
    navigate(`/lawn-mowing/franchises/edit/${item.id}`);
  }
  else if (item.type === "poolcare_business") {
    navigate(`/poolcare/businesses/edit/${item.id}`);
  }
  else if (item.type === "cleaning") {
    navigate(`/cleaning/listings/edit/${item.id}`);
  }

  /* ✅ ADD THIS BLOCK */
  else if (item.type === "poolcare_listing") {
    navigate(`/poolcare/listings/edit/${item.id}`);
  }

  else if (item.type === "cleaning_swap") {
    navigate(`/cleaning/swaps/edit/${item.listingId}`);
  }
  else if (item.type === "poolcare_swap") {
    navigate(`/poolcare/swaps/edit/${item.listingId}`);
  }
  else if (item.type === "mowing_swap") {
    navigate(`/swaps/edit/${item.id}`);
  }
};


const toggleListing = async (item, newStatus) => {
  if (!window.confirm(`Change status to ${newStatus}?`)) return;

  try {
    const token = localStorage.getItem("token");

    // 🔹 MOWING SWAP (uses hidden field)
    if (item.type === "mowing_swap") {
      const hiddenValue = newStatus === "inactive" ? 1 : 0;

      await axios.patch(
        `${API_BASE_URL}/api/swap-listings/${item.id}/toggle`,
        { hidden: hiddenValue },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

     setListings((prev) =>
  prev.map((l) =>
    l.id === item.id && l.type === item.type
      ? { ...l, status: hiddenValue === 1 ? "inactive" : "available" }
      : l
  )
);

      return; // 🚨 STOP here so other logic doesn't run
    }

 // 🔹 CLEANING SWAP (ADD THIS BLOCK)
if (item.type === "cleaning_swap") {
  await axios.patch(
    `${API_BASE_URL}/api/cleaning/swap-listings/${item.id}/toggle-status`,
    { newStatus },
    {
      headers: { Authorization: `Bearer ${token}` },
    }
  );

 setListings((prev) =>
  prev.map((l) =>
    l.id === item.id && l.type === item.type
      ? { ...l, status: newStatus }
      : l
  )
);

  return;
}

// 🔹 LAWN MOWING ROUND
if (item.type === "round") {
  await axios.patch(
    `${API_BASE_URL}/api/lawn-mowing/rounds/${item.id}/toggle-status`,
    { newStatus },
    { headers: { Authorization: `Bearer ${token}` } }
  );

  setListings((prev) =>
    prev.map((l) =>
      l.id === item.id && l.type === item.type
        ? { ...l, status: newStatus }
        : l
    )
  );

  return;
}

// 🔹 CLEANING ROUND
if (item.type === "cleaning_round") {
  await axios.patch(
    `${API_BASE_URL}/api/cleaning/rounds/${item.id}/toggle-status`,
    { newStatus },
    {
      headers: { Authorization: `Bearer ${token}` },
    }
  );

  setListings((prev) =>
    prev.map((l) =>
      l.id === item.id && l.type === item.type
        ? { ...l, status: newStatus }
        : l
    )
  );

  return;
}

// 🔹 POOLCARE SWAP
if (item.type === "poolcare_swap") {
  await axios.put(
    `${API_BASE_URL}/api/poolcare/swap-listings/${item.listingId}/toggle-visibility`,
    {},
    {
      headers: { Authorization: `Bearer ${token}` },
    }
  );

setListings((prev) =>
  prev.map((l) =>
    l.id === item.id && l.type === item.type
      ? {
          ...l,
          status:
            l.status === "inactive"
              ? "available"
              : "inactive",
        }
      : l
  )
);

  return;
}

// 🔹 POOLCARE BUSINESS
if (item.type === "poolcare_business") {
  const statusToSend = newStatus === "inactive" ? "draft" : newStatus;

  await axios.patch(
    `${API_BASE_URL}/api/poolcare/business-franchise/${item.id}/toggle-status`,
    { newStatus: statusToSend },
    {
      headers: { Authorization: `Bearer ${token}` },
    }
  );

  setListings((prev) =>
    prev.map((l) =>
      l.id === item.id && l.type === item.type
        ? { ...l, status: statusToSend }
        : l
    )
  );

  return;
}

// 🔹 POOLCARE LISTING
if (item.type === "poolcare_listing") {
  await axios.patch(
    `${API_BASE_URL}/api/poolcare/listings/${item.id}/toggle-visibility`,
    {},
    {
      headers: { Authorization: `Bearer ${token}` },
    }
  );

  // Reload to sync with DB hidden flag
  window.location.reload();
  return;
}




// 🔹 ALL OTHER LISTINGS (LEAVE THIS AS IS)
await axios.patch(
  `${API_BASE_URL}/api/${item.type === "cleaning" ? "cleaning/listings" : "listings"}/${item.id}/toggle-status`,
  { newStatus },
  {
    headers: { Authorization: `Bearer ${token}` },
  }
);


    setListings((prev) =>
      prev.map((l) =>
        l.id === item.id ? { ...l, status: newStatus } : l
      )
    );
  } catch (err) {
    console.error("Toggle failed:", err);
    alert("Failed to update status.");
  }
};

const deleteMowingSwap = async (item) => {
  if (item.type !== "mowing_swap") return;

  if (
    !window.confirm(
      "Delete this mowing swap listing? This will remove it from My Listings."
    )
  ) {
    return;
  }

  try {
    const token = localStorage.getItem("token");

    await axios.patch(
      `${API_BASE_URL}/api/swap-listings/${item.id}/delete`,
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    setListings((prev) =>
      prev.filter((l) => !(l.id === item.id && l.type === item.type))
    );

    alert("Mowing swap listing deleted.");
  } catch (err) {
    console.error("Delete mowing swap failed:", err);
    alert(
      err.response?.data?.message ||
        "Could not delete mowing swap listing."
    );
  }
};

const deleteCleaningSwap = async (item) => {
  if (item.type !== "cleaning_swap") return;

  if (
    !window.confirm(
      "Delete this cleaning swap listing? This will remove it from My Listings."
    )
  ) {
    return;
  }

  try {
    const token = localStorage.getItem("token");

    await axios.patch(
      `${API_BASE_URL}/api/cleaning/swap-listings/${item.id}/delete`,
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    setListings((prev) =>
      prev.filter((l) => !(l.id === item.id && l.type === item.type))
    );

    alert("Cleaning swap listing deleted.");
  } catch (err) {
    console.error("Delete cleaning swap failed:", err);
    alert(
      err.response?.data?.message ||
        "Could not delete cleaning swap listing."
    );
  }
};

const deletePoolcareSwap = async (item) => {
  if (item.type !== "poolcare_swap") return;

  if (
    !window.confirm(
      "Delete this pool care swap listing? This will remove it from My Listings."
    )
  ) {
    return;
  }

  try {
    const token = localStorage.getItem("token");

    await axios.patch(
      `${API_BASE_URL}/api/poolcare/swap-listings/${item.id}/delete`,
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    setListings((prev) =>
      prev.filter((l) => !(l.id === item.id && l.type === item.type))
    );

    alert("Pool care swap listing deleted.");
  } catch (err) {
    console.error("Delete pool care swap failed:", err);
    alert(
      err.response?.data?.message ||
        "Could not delete pool care swap listing."
    );
  }
};

  const badgeColor = {
    listing: "#2e7d32",
    round: "#1565c0",
    business: "#6a1b9a",
    franchise: "#ef6c00",
    cleaning: "#00897b",
    cleaning_swap: "#455a64",
    mowing_swap: "#37474f",
    cleaning_round: "#00796b",
    cleaning_business: "#0288d1",
    cleaning_franchise: "#ff7043",
    poolcare_swap: "#006064",
    poolcare_business: "#00796b",
    poolcare_listing: "#006064",






  };
const hiddenStatuses = [
  "sold",
  "completed",
  "handover",
  "locked",
  "archived",
  "pending_payment"
];
const visibleListings = listings.filter((item) => {
  const status = (item.status || "").toLowerCase();
  return !hiddenStatuses.includes(status);
});
  return (
    <div style={{ background: "#f7fdf7", minHeight: "100vh" }}>
      <div style={hero}>
        <img src={logo} alt="Client Exchange" style={heroLogo} />
        <h1 style={{ fontWeight: 800 }}>My Listings</h1>
        <p>All your clients, rounds, businesses & franchises</p>
      </div>

      <div style={grid}>
       {visibleListings.map((item) => (
          <div key={`${item.type}-${item.id}`} style={card}>
            <div style={cardHeader}>
              <span
                style={{
                  ...badge,
                  background: badgeColor[item.type],
                }}
              >
                {item.type.toUpperCase()}
              </span>
            </div>

           <h3 style={title}>{item.title}</h3>
<p style={suburb}>{item.suburb}</p>
<p style={price}>${item.price}</p>



<p style={meta}>
  <strong>Listing ID:</strong>{" "}
  {item.listingId || item.id}
</p>


            <div style={actions}>
              <button style={viewBtn} onClick={() => openListing(item)}>
                View
              </button>
              <button style={editBtn} onClick={() => editListing(item)}>
                Edit
              </button>
{/* DEACTIVATE BUTTON */}
{![
  "inactive",
  "completed",
  "handover",
  "locked",
  "sold",
  "expired",
  "draft",
  "pending",
  "pending_payment",
  "archived"
].includes(item.status) && (
  <button
    style={deactivateBtn}
    onClick={() => toggleListing(item, "inactive")}
  >
    Deactivate
  </button>
)}

{/* DELETE MOWING SWAP BUTTON */}
{item.type === "mowing_swap" && item.status === "available" && (
  <button
    style={deleteBtn}
    onClick={() => deleteMowingSwap(item)}
  >
    Delete
  </button>
)}

{/* DELETE CLEANING SWAP BUTTON */}
{item.type === "cleaning_swap" && item.status === "available" && (
  <button
    style={deleteBtn}
    onClick={() => deleteCleaningSwap(item)}
  >
    Delete
  </button>
)}

{/* DELETE POOL CARE SWAP BUTTON */}
{item.type === "poolcare_swap" && item.status === "available" && (
  <button
    style={deleteBtn}
    onClick={() => deletePoolcareSwap(item)}
  >
    Delete
  </button>
)}

{/* REACTIVATE BUTTON */}
{item.status === "inactive" && (
  <button
    style={reactivateBtn}
    onClick={() =>
      toggleListing(
        item,
        item.type === "mowing_swap"
          ? "available"
          : item.type === "cleaning_swap"
          ? "available"
          : item.type === "listing"
          ? "live"
          : "active"
      )
    }
  >
    Reactivate
  </button>
)}

{/* POOLCARE BUSINESS REACTIVATE */}
{item.type === "poolcare_business" && item.status === "draft" && (
  <button
    style={reactivateBtn}
    onClick={() => toggleListing(item, "active")}
  >
    Reactivate
  </button>
)}

            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

/* ===== STYLES (UNCHANGED) ===== */

const hero = {
  background: "linear-gradient(135deg, #2e7d32, #1b5e20)",
  padding: "50px 20px",
  textAlign: "center",
  color: "#fff",
  marginBottom: 30,
};

const heroLogo = {
  width: 190,
  marginBottom: 15,
};

const grid = {
  width: "92%",
  margin: "0 auto",
  display: "grid",
  gridTemplateColumns: "repeat(auto-fill, minmax(300px, 1fr))",
  gap: 30,
  paddingBottom: 60,
};

const card = {
  background: "#fff",
  borderRadius: 18,
  padding: 22,
  boxShadow: "0 8px 22px rgba(0,0,0,0.12)",
  transition: "transform .25s ease, box-shadow .25s ease",
};

const cardHeader = {
  display: "flex",
  justifyContent: "flex-end",
  marginBottom: 10,
};

const badge = {
  color: "#fff",
  padding: "6px 14px",
  borderRadius: 20,
  fontSize: "0.75rem",
  fontWeight: 700,
};

const title = {
  fontWeight: 800,
  fontSize: "1.1rem",
};

const suburb = {
  color: "#555",
  marginBottom: 8,
};

const price = {
  fontSize: "1.6rem",
  fontWeight: 900,
  color: "#2e7d32",
};

const meta = {
  fontSize: "0.85rem",
  color: "#666",
};

const actions = {
  display: "flex",
  gap: 10,
  marginTop: 15,
};

const baseBtn = {
  flex: 1,
  padding: "10px",
  borderRadius: 8,
  border: "none",
  color: "#fff",
  fontWeight: 700,
  cursor: "pointer",
};

const viewBtn = { ...baseBtn, background: "#2e7d32" };
const editBtn = { ...baseBtn, background: "#1565c0" };
const deactivateBtn = { ...baseBtn, background: "#757575" };
const reactivateBtn = { ...baseBtn, background: "#2e7d32" };
const deleteBtn = { ...baseBtn, background: "#c62828" };

